import React from 'react';
import { MENU_ENTRIES } from '../constants';

import ZipCompression from './zip-compression';

const CreatingZipFile = () => (
  <div data-subsection={MENU_ENTRIES.creatingZipFile}>
    <h3>
      STEP 5: CREATING A ZIP FILE
    </h3>
    <p>
      When the folder containing the XML file(s) and the attached image(s) is ready, it <strong>MUST</strong> be compressed in ZIP format.
    </p>
    <p className="pt-callout pt-intent-warning pt-icon-info-sign">
      <strong>Important:</strong> The folder to be compressed <strong>MUST NOT</strong> contain subfolders.
    </p>
    <br/>
    <ZipCompression/>
  </div>
);

export default CreatingZipFile;


// WEBPACK FOOTER //
// ./src/views/static/import-documentation/creating-zip-file/index.js